export const NONE = 0
export const TAG_NARROW_DOWN = 1
export const AUTHOR_NARROW_DOWN = 2
export const DATE_JUMP_CONTROLL = 3
export const TAG_SELECTION = 4
export const PUSH_TARGET_SELECTION = 5
export const POST_TARGET_DATE_SELECTION = 6
export const CONFIRM_DIALOG = 100
